import getUnchangedTrip from './getUnchangedTrip';

const getUnchangedTripIds = (canExchange, trips, pastJourneyElementTrips) => {
  const unchangedTrip = getUnchangedTrip(canExchange, trips, pastJourneyElementTrips);

  return unchangedTrip ? [unchangedTrip.reservationTripId] : [];
};

export default getUnchangedTripIds;
